export const HALF_YEAR_LABELS = ['1 полугодие', '2 полугодие'] as const;
